import { createContext } from 'react';

export const BatchExportQueueContext = createContext({ 
  batchExportQueue: [], 
  setBatchExportQueue: () => {} 
}); 